import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MessengerPageRoutingModule } from './messenger-routing.module';

import { MessengerPage } from './messenger.page';
import { MIComponentsModule } from 'src/app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconButtonModule } from 'src/app/modules/icon-button/icon-button.module';
import { MessengerService } from 'src/app/services/messenger/messenger.service';
import { MIButtonsModule } from 'src/app/modules/buttons/buttons.module';
import { LayoutModule } from 'src/app/modules/layout/layout.module';
import { IconComponent } from 'src/app/modules/icon/icon.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MIButtonsModule,
    MIComponentsModule,
    TranslateModule,
    IconButtonModule,
    MessengerPageRoutingModule,
    LayoutModule,
    IconComponent
  ],
  declarations: [MessengerPage],
  providers: [
    MessengerService,
    // TODO: if service is loaded in app.component two different instances are created
    // but we need only one, so I think we shouldn't provide it here
    // SocketService
  ]
})
export class MessengerPageModule {}
